import { render, staticRenderFns } from "./GameTypeRestrictions.vue?vue&type=template&id=246c4610&scoped=true&"
import script from "./GameTypeRestrictions.vue?vue&type=script&lang=js&"
export * from "./GameTypeRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./GameTypeRestrictions.vue?vue&type=style&index=0&id=246c4610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c4610",
  null
  
)

export default component.exports